<template>
  <div class="container-fluid">
    <TableRowModal
      v-model="mixin_tableRowModal.show"
      :title="mixin_tableRowModal.title"
      :items="mixin_tableRowModal.items"
      :tableRowModalFields="mixin_tableRowModal.fields"
    />
    <div class="row">
      <div class="col-12">
        <div class="page-table-header">
          <PageHeader :page-title="'Finance reports - profit and loss calculator'">
            <template v-slot:buttons>
              <b-button
                class="button title-container__controls-item"
                :variant="isShowFilter ? 'secondary' : 'info'"
                @click="toggleShowFilter"
              >
                <span class="material-icons icon-image-preview">
                  tune
                </span>
                Filters
              </b-button>
              <b-button
                variant="success"
                :disabled="!isReports"
                class="button"
                @click.prevent="getCalculateProfitAndLoss"
              >
                Calculate
              </b-button>
            </template>
          </PageHeader>

          <Filters
            v-show="isShowFilter"
            textButtonSubmit="Get Report"
            :data="mixin_filters"
            :isLoading="isDataPageLoading"
            withGroups
            @submit="_getReportsProfitAndLoss"
          />

          <TableForPage
            ref="table"
            style="margin-bottom: 0;"
            v-if="totalReports.length"
            :tableData="totalReports"
            :fields="fieldsReports"
            :tableDescription="columnDescription"
            :cell-fixed="true"
            showTopControls
            showTotalTable
          >
            <template v-slot:tableControlsRight>
              <b-button
                class="ml-auto"
                size="sm"
                @click="showColumns = !showColumns"
              >
                <span v-if="showColumns">Hide</span>
                <span v-else>Show</span>
                RUB/GBP columns
              </b-button>
            </template>
            <template v-slot:row="slotProps">
              <template v-if="slotProps.row.item.column_group === config.groupName.expenses">
                <NestedTable
                  style="margin-bottom: 0;"
                  :items="slotProps.row.item.categories"
                  :fields="nestedFieldsReports"
                  :slots="slotsEditCategoryExpenses"
                  :modalFields="modalFieldsReports"
                  :modalSlots="slotsEditExpenses"
                  :current-edit="editRow"
                  @close-edit="clearEditRow($event)"
                  rowName="expenses"
                >
                  <template v-slot:modal-controls="slotControl">
                    <ReportTableControls
                      :isEdit="!isEditType(slotControl.index, `${config.editRowName.expenses}-${slotProps.row.item.name}`)"
                      :without-add="true"
                      @edit="setEditRow(`${config.editRowName.expenses}-${slotProps.row.item.name}-${slotControl.index}`, slotControl.item, 'Expenses')"
                      @save="clearEditRow()"
                      @remove="removeRow(slotProps.row.item, slotControl.index, 'expenses')"
                    />
                  </template>
                  <template v-for="item in currency" v-slot:[`modal-total.original.${item}`]="slotExpenses">
                    <TDWithChange
                      :key="item"
                      :data-td="slotExpenses.item.total.original"
                      :input-type="'number'"
                      :text-field="item"
                      :check-currency-values="true"
                      :isEdit="isEditType(slotExpenses.index, `${config.editRowName.expenses}-${slotProps.row.item.name}`)"
                    />
                  </template>
                  <template v-slot:modal-total.equivalent.USD="slotExpenses">
                    {{ slotExpenses.item.total.equivalent.USD }}
                  </template>
                  <template v-slot:modal-status.name="slotExpenses">
                    <TDWithChange
                      :data-td="slotExpenses.item.status"
                      :input-type="'select'"
                      :text-field="'display_name'"
                      :selectOptions="_getExpensesStatuses"
                      :isEdit="isEditType(slotExpenses.index, `${config.editRowName.expenses}-${slotProps.row.item.name}`)"
                      :label-status="true"
                      @changeSelect="setSelectedStatus($event, slotExpenses.item)"
                    />
                  </template>
                  <template v-slot:modal-due_date="slotExpenses">
                    <TDWithChange
                      :data-td="slotExpenses.item"
                      :input-type="'datepicker'"
                      :text-field="'due_date'"
                      :isEdit="isEditType(slotExpenses.index, `${config.editRowName.expenses}-${slotProps.row.item.name}`)"
                    />
                  </template>
                  <template v-slot:modal-paid_date="slotExpenses">
                    <TDWithChange
                      :data-td="slotExpenses.item"
                      :input-type="'datepicker'"
                      :text-field="'paid_date'"
                      :isEdit="isEditType(slotExpenses.index, `${config.editRowName.expenses}-${slotProps.row.item.name}`)"
                    />
                  </template>
                  <template v-slot:controls="slotControl">
                    <ReportTableControls
                      :isEdit="!isEditType(slotControl.index, config.editRowName.expensesCategory)"
                      @add="addTableRow(slotProps.row.item, 'categories', slotControl.index, config.mockForTable.expensesCategory)"
                      @edit="setEditRow(`${config.editRowName.expensesCategory}-${slotControl.index}`, slotControl.item)"
                      @save="clearEditRow"
                      @remove="removeRow(slotProps.row.item, slotControl.index, 'categories')"
                    />
                  </template>
                  <template v-slot:name="slotName">
                    <TDWithChange
                      :data-td="slotName.item"
                      :input-type="'text'"
                      :text-field="'name'"
                      :isEdit="isEditType(slotName.index, config.editRowName.expensesCategory)"
                    />
                  </template>
                </NestedTable>
              </template>
              <template v-if="slotProps.row.item.column_group === config.groupName.payouts">
                <b-tabs card>
                  <b-tab title="By payees">
                    <NestedTable
                      :items="slotProps.row.item.payees"
                      :fields="fieldsPayoutsReports"
                      :slots="slotsEditPayouts"
                    >
                      <template v-slot:controls="slotControl">
                        <ReportTableControls
                          :isEdit="!isEditType(slotControl.index, config.editRowName.payouts)"
                          @add="() => addTableRow(slotProps.row.item, 'payees', slotControl.index, config.mockForTable.payouts)"
                          @edit="setEditRow(`${config.editRowName.payouts}-${slotControl.index}`, slotControl.item)"
                          @save="clearEditRow"
                          @remove="removeRow(slotProps.row.item, slotControl.index, 'payees')"
                        />
                      </template>
                      <template v-slot:name="slotName">
                        <TDWithChange
                          :data-td="slotName.item"
                          :input-type="'text'"
                          :text-field="'name'"
                          :isEdit="isEditType(slotName.index, config.editRowName.payouts)"
                        />
                      </template>
                      <template v-for="item in currency" v-slot:[`total.original.${item}`]="slotPayouts">
                        <TDWithChange
                          :key="item"
                          :data-td="slotPayouts.item.total.original"
                          :input-type="'number'"
                          :text-field="item"
                          :check-currency-values="true"
                          :isEdit="isEditType(slotPayouts.index, config.editRowName.payouts)"
                        />
                      </template>
                      <template v-slot:total.equivalent.USD="slotPayouts">
                        {{ slotPayouts.item.total.equivalent.USD }}
                      </template>
                    </NestedTable>
                  </b-tab>
                  <b-tab title="By sales channel">
                    <NestedTable
                      :items="slotProps.row.item.salesChannels"
                      :fields="fieldsPayoutsReports"
                      :slots="slotsEditPayouts"
                    >
                      <template v-slot:controls="slotControl">
                        <ReportTableControls
                          :isEdit="!isEditType(slotControl.index, config.editRowName.payouts)"
                          @add="() => addTableRow(slotProps.row.item, 'salesChannels', slotControl.index, config.mockForTable.payouts)"
                          @edit="setEditRow(`${config.editRowName.payouts}-${slotControl.index}`, slotControl.item)"
                          @save="clearEditRow"
                          @remove="removeRow(slotProps.row.item, slotControl.index, 'salesChannels')"
                        />
                      </template>
                      <template v-slot:name="slotName">
                        <TDWithChange
                          :data-td="slotName.item"
                          :input-type="'text'"
                          :text-field="'name'"
                          :isEdit="isEditType(slotName.index, config.editRowName.payouts)"
                        />
                      </template>
                      <template v-for="item in currency" v-slot:[`total.original.${item}`]="slotPayouts">
                        <TDWithChange
                          :key="item"
                          :data-td="slotPayouts.item.total.original"
                          :input-type="'number'"
                          :text-field="item"
                          :check-currency-values="true"
                          :isEdit="isEditType(slotPayouts.index, config.editRowName.payouts)"
                        />
                      </template>
                      <template v-slot:total.equivalent.USD="slotPayouts">
                        {{ slotPayouts.item.total.equivalent.USD }}
                      </template>
                    </NestedTable>
                  </b-tab>
                </b-tabs>
              </template>
              <template v-if="slotProps.row.item.column_group === config.groupName.payments">
                <NestedTable
                  style="margin-bottom: 0;"
                  :items="slotProps.row.item.business_developers"
                  :fields="nestedFieldsReports"
                  :slots="slotsEditPayments"
                  :modalFields="modalFieldsPayments"
                  :modalSlots="slotsModalEditPayments"
                  rowName="projects"
                >
                  <template v-slot:modal-controls="slotControl">
                    <ReportTableControls
                      :isEdit="!isEditType(slotControl.index, `${config.editRowName.paymentsProject}-${slotProps.row.item.name}`)"
                      @add="addTableRow(slotProps.row.item, 'projects', slotControl.index, config.mockForTable.paymentsProjects)"
                      @edit="setEditRow(`${config.editRowName.paymentsProject}-${slotProps.row.item.name}-${slotControl.index}`, slotControl.item)"
                      @save="clearEditRow"
                      @remove="removeRow(slotProps.row.item, slotControl.index, 'projects')"
                    />
                  </template>
                  <template v-slot:modal-name="slotName">
                    <TDWithChange
                      :data-td="slotName.item"
                      :input-type="'text'"
                      :text-field="'name'"
                      :isEdit="isEditType(slotName.index, `${config.editRowName.paymentsProject}-${slotProps.row.item.name}`)"
                    />
                  </template>

                  <template v-slot:modal-row="slotInvoices">
                    <NestedTable
                      :items="slotInvoices.row.item.invoices"
                      :fields="fieldsReportsPayments"
                      :slots="slotsEditPaymentsInvoice"
                    >
                      <template v-slot:controls="slotControl">
                        <ReportTableControls
                          :current-edit="editRow"
                          @close-edit="clearEditRow($event)"
                          :isEdit="!isEditType(slotControl.index, `${config.editRowName.paymentsInvoices}-${slotProps.row.item.name}`)"
                          @add="addTableRow(slotInvoices.row.item, 'invoices', slotControl.index, config.mockForTable.paymentsInvoices)"
                          @edit="setEditRow(`${config.editRowName.paymentsInvoices}-${slotProps.row.item.name}-${slotControl.index}`, slotControl.item)"
                          @save="clearEditRow"
                          @remove="removeRow(slotInvoices.row.item, slotControl.index, 'invoices')"
                        />
                      </template>
                      <template v-slot:number="slotProps">
                        <a href="#" @click.prevent="() => _showRowModal(slotProps.item)">
                          {{slotProps.item.number}}
                        </a>
                      </template>
                      <template v-for="item in currency" v-slot:[`total.original.${item}`]="slotExpenses">
                        <TDWithChange
                          :key="item"
                          :data-td="slotExpenses.item.total.original"
                          :input-type="'number'"
                          :text-field="item"
                          :check-currency-values="true"
                          :isEdit="isEditType(slotExpenses.index, `${config.editRowName.paymentsInvoices}-${slotProps.row.item.name}`)"
                        />
                      </template>
                      <template v-slot:total.equivalent.USD="slotExpenses">
                        {{ slotExpenses.item.total.equivalent.USD }}
                      </template>
                      <template v-slot:status.name="slotExpenses">
                        <TDWithChange
                          :data-td="slotExpenses.item.status"
                          :input-type="'select'"
                          :text-field="'display_name'"
                          :selectOptions="_getExpensesStatuses"
                          :isEdit="isEditType(slotExpenses.index, `${config.editRowName.paymentsInvoices}-${slotProps.row.item.name}`)"
                          :label-status="true"
                          @changeSelect="setSelectedStatus($event, slotExpenses.item)"
                        />
                      </template>
                      <template v-slot:due_date="slotExpenses">
                        <TDWithChange
                          :data-td="slotExpenses.item"
                          :input-type="'datepicker'"
                          :text-field="'due_date'"
                          :isEdit="isEditType(slotExpenses.index, `${config.editRowName.expenses}-${slotProps.row.item.name}`)"
                        />
                      </template>
                      <template v-slot:paid_date="slotExpenses">
                        <TDWithChange
                          :data-td="slotExpenses.item"
                          :input-type="'datepicker'"
                          :text-field="'paid_date'"
                          :isEdit="isEditType(slotExpenses.index, `${config.editRowName.expenses}-${slotProps.row.item.name}`)"
                        />
                      </template>
                    </NestedTable>
                  </template>

                  <template v-slot:controls="slotControl">
                    <ReportTableControls
                      :isEdit="!isEditType(slotControl.index, config.editRowName.paymentsUser)"
                      @add="addTableRow(slotProps.row.item, 'business_developers', slotControl.index, config.mockForTable.payments)"
                      @edit="setEditRow(`${config.editRowName.paymentsUser}-${slotControl.index}`, slotControl.item)"
                      @save="clearEditRow"
                      @remove="removeRow(slotProps.row.item, slotControl.index, 'business_developers')"
                    />
                  </template>
                  <template v-slot:name="slotName">
                    <TDWithChange
                      :data-td="slotName.item"
                      :input-type="'text'"
                      :text-field="'name'"
                      :isEdit="isEditType(slotName.index, config.editRowName.paymentsUser)"
                    />
                  </template>
                </NestedTable>
              </template>
            </template>
            <template v-slot:total>
              <b-table
                class="table__total without-head"
                :items="itemsReportsSummary"
                :fields="fieldsReports"
                :isShowMoreButton="false"
                :fixed="true"
              >
                <template v-slot:total.equivalent.percent="slotProps">
                  <div :class="['finance-summary-percent-' + _getClassByPercent(slotProps.item.total.equivalent.percent)]">
                    {{ slotProps.item.total.equivalent.percent }} %
                  </div>
                </template>
              </b-table>
            </template>
          </TableForPage>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { permissions } from '@mocks/permissions'
import TableRowModal from '@tables/TableRowModal'
import ReportTableControls from '@tables/elements/ReportTableControls'
import moment from 'moment'
import Filters from '@components/Filter/Filter'
import PageHeader from '@components/PageHeader'
import TableForPage from '@tables/TableForPage'
import NestedTable from '@tables/NestedTable'
import { cloneDeep } from 'lodash'
import TDWithChange from '@tables/elements/TDWithChange'

import FinanceReportsProfitAndLoss from '../mixins/FinanceReportsProfitAndLoss'

const currentDate = moment().format('YYYY-MM-DD')
const mockTotal = {
  equivalent: { UAH: 0, USD: 0, EUR: 0, RUB: 0, GBP: 0, percent: 0 },
  original: { UAH: 0, USD: 0, EUR: 0, RUB: 0, GBP: 0 }
}
const mockExpenses = {
  comment: '',
  due_date: currentDate,
  paid_date: currentDate,
  status: { id: 2, name: 'invoice_received', display_name: 'Invoice received' },
  total: JSON.parse(JSON.stringify(mockTotal))
}
const mockPaymentsInvoices = {
  id: 0,
  due_date: currentDate,
  hours: '',
  number: '',
  paid_date: currentDate,
  status: { id: 2, name: 'invoice_received', display_name: 'Invoice received' },
  total: JSON.parse(JSON.stringify(mockTotal))
}
const paymentsProjects = {
  name: 'Test Project',
  invoices: [mockPaymentsInvoices],
  total: JSON.parse(JSON.stringify(mockTotal))
}

export default {
  name: 'FinanceReportsProfitAndCalculator',
  components: {
    TableRowModal,
    ReportTableControls,
    Filters,
    TableForPage,
    NestedTable,
    TDWithChange,
    PageHeader
  },
  mixins: [FinanceReportsProfitAndLoss],
  data () {
    return {
      permissions: permissions,
      isShowFilter: true,
      editRow: null,
      editData: null,
      showColumns: false,
      config: {
        formatDate: 'yyyy-MM-dd',
        groupName: {
          expenses: 'Expenses',
          payouts: 'Payouts',
          payments: 'Payments',
          summary: 'Total'
        },
        editRowName: {
          expenses: 'expenses-index',
          expensesCategory: 'expenses-category-index',
          payouts: 'payouts-index',
          paymentsUser: 'payments-user-index',
          paymentsProject: 'payments-project-index',
          paymentsInvoices: 'payments-invoices-index'
        },
        mockForTable: {
          expensesCategory: {
            expenses: [
              mockExpenses
            ],
            name: 'Mock expenses',
            total: JSON.parse(JSON.stringify(mockTotal))
          },
          expenses: mockExpenses,
          payouts: {
            name: 'Test User',
            total: JSON.parse(JSON.stringify(mockTotal))
          },
          payments: {
            name: 'Test User',
            projects: [
              paymentsProjects
            ],
            total: JSON.parse(JSON.stringify(mockTotal))
          },
          paymentsProjects: paymentsProjects,
          paymentsInvoices: mockPaymentsInvoices
        }
      },
      currencyColumns: [
        {
          key: 'total.original.UAH',
          label: 'UAH',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'total.original.USD',
          label: 'USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'total.original.EUR',
          label: 'EUR',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'total.original.RUB',
          label: 'RUB',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'total.original.GBP',
          label: 'GBR',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'total.equivalent.USD',
          label: 'Eq USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'total.equivalent.percent',
          label: 'Percent',
          sortable: true,
          class: 'column-amount',
          formatter: value => {
            return `${value} %`
          }
        }
      ],
      datesColumns: [
        {
          key: 'due_date',
          label: 'Due Date',
          class: 'column-amount'
        },
        {
          key: 'paid_date',
          label: 'Paid Date',
          class: 'column-amount'
        }
      ],
      isDataPageLoading: false,
      slotsEditCategoryExpenses: {
        'name': {
          name: 'name'
        },
        controls: {
          name: 'controls'
        }
      },
      slotsEditExpenses: {
        'total.original.UAH': {
          name: 'total.original.UAH'
        },
        'total.original.USD': {
          name: 'total.original.USD'
        },
        'total.original.EUR': {
          name: 'total.original.EUR'
        },
        'total.original.RUB': {
          name: 'total.original.RUB'
        },
        'total.original.GBP': {
          name: 'total.original.GBP'
        },
        'status.name': {
          name: 'status.name'
        },
        'due_date': {
          name: 'due_date'
        },
        'paid_date': {
          name: 'paid_date'
        },
        'controls': {
          name: 'controls'
        }
      },
      slotsEditPayouts: {
        'name': {
          name: 'name'
        },
        'total.original.UAH': {
          name: 'total.original.UAH'
        },
        'total.original.USD': {
          name: 'total.original.USD'
        },
        'total.original.EUR': {
          name: 'total.original.EUR'
        },
        'total.original.RUB': {
          name: 'total.original.RUB'
        },
        'total.original.GBP': {
          name: 'total.original.GBP'
        },
        'status.name': {
          name: 'status.name'
        },
        'due_date': {
          name: 'due_date'
        },
        'paid_date': {
          name: 'paid_date'
        },
        controls: {
          name: 'controls'
        }
      },
      slotsEditPayments: {
        name: {
          name: 'name'
        },
        controls: {
          name: 'controls'
        }
      },
      slotsModalEditPayments: {
        name: {
          name: 'name'
        },
        controls: {
          name: 'controls'
        }
      },
      slotsEditPaymentsInvoice: {
        number: {
          name: 'number'
        },
        name: {
          name: 'name'
        },
        'total.original.UAH': {
          name: 'total.original.UAH'
        },
        'total.original.USD': {
          name: 'total.original.USD'
        },
        'total.original.EUR': {
          name: 'total.original.EUR'
        },
        'total.original.RUB': {
          name: 'total.original.RUB'
        },
        'total.original.GBP': {
          name: 'total.original.GBP'
        },
        'status.name': {
          name: 'status.name'
        },
        'due_date': {
          name: 'due_date'
        },
        'paid_date': {
          name: 'paid_date'
        },
        controls: {
          name: 'controls'
        }
      },
      slotsSummary: {
        'total.equivalent.percent': {
          name: 'total.equivalent.percent'
        }
      },
      totalReports: [],
      itemsReportsSummary: [],
      columnDescription: [
        '<strong>Status</strong> = ',
        '<strong>Info</strong> = ',
        '<strong>Am</strong> = ',
        '<strong>Eq</strong> = '
      ],
      currency: [
        'UAH',
        'USD',
        'EUR',
        'RUB',
        'GBP'
      ]
    }
  },
  computed: {
    isReports () {
      return this.totalReports.length
    },
    getCurrencyColumns () {
      if (this.showColumns) {
        return this.currencyColumns
      } else {
        return this.currencyColumns.filter(f => {
          return f.key !== 'total.original.GBP' && f.key !== 'total.original.RUB'
        })
      }
    },
    fieldsReports () {
      return [
        {
          key: 'column_group',
          label: 'Group',
          sortable: true,
          class: 'column-bd-name font-weight-bold'
        },
        ...this.getCurrencyColumns,
        {
          key: 'more',
          label: 'More',
          class: 'column-more'
        }
      ]
    },
    nestedFieldsReports () {
      return [
        {
          key: 'name',
          label: 'Name',
          class: 'column-bd-name'
        },
        ...this.getCurrencyColumns,
        {
          key: 'controls',
          label: 'Actions',
          class: 'column_action'
        },
        {
          key: 'more',
          label: 'More',
          class: 'column-more'
        }
      ]
    },
    fieldsPayoutsReports () {
      return [
        {
          key: 'name',
          label: 'Name',
          class: 'column-bd-name'
        },
        ...this.getCurrencyColumns,
        {
          key: 'controls',
          label: 'Actions',
          class: 'column_action'
        }
      ]
    },
    modalFieldsReports () {
      return [
        ...this.getCurrencyColumns,
        {
          key: 'status.name',
          label: 'Status',
          class: 'column-status'
        },
        ...this.datesColumns,
        {
          key: 'controls',
          label: 'Actions',
          class: 'column_action'
        }
      ]
    },
    modalFieldsPayments () {
      return [
        ...this.getCurrencyColumns,
        {
          key: 'more',
          label: 'More',
          class: 'column-more'
        }
      ]
    },
    fieldsReportsPayments () {
      return [
        {
          key: 'number',
          label: 'Name',
          sortable: true,
          class: 'column-bd-name'
        },
        ...this.getCurrencyColumns,
        {
          key: 'status.name',
          label: 'Status',
          sortable: true,
          class: 'column-status'
        },
        ...this.datesColumns,
        {
          key: 'hours',
          label: 'Hrs',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'controls',
          label: 'Controls',
          class: 'column_action'
        }
      ]
    }
  },
  created () {
    this._fetchAllData()
  },
  methods: {
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    getCalculateProfitAndLoss () {
      if (!this.isReports) {
        return this.$snotify.error(
          'You don\'t have reports',
          'Error',
          this.$store.state.snotify
        )
      }

      const data = this.prepareDataForCalculateRequest([...this.totalReports, ...this.itemsReportsSummary])

      this._toggleDataPageLoading(async () => {
        await this.$api.finances.getReportsProfitAndLossCalculator(data).then(res => {
          this.setReportsDataTotalFromRequest(res.data)
        })
      })
    },
    prepareDataForCalculateRequest (data) {
      let result = {}

      data.forEach(item => {
        result[item.server_name] = item
      })

      return result
    },
    setSelectedStatus (e, item) {
      const selectStatuses = this._getExpensesStatuses.find(item => item.id === e.id)
      item['status'] = selectStatuses
    },
    setRowData (date, type, newValue) {
      date[type] = this._toLocalTime(newValue)
    },
    setEditRow (data, value, type) {
      this.editData = JSON.parse(JSON.stringify(this.totalReports))
      this.editRow = data
    },
    removeRow (data, removeIndex, type) {
      if (data[type].length === 1) {
        return this.$snotify.error(
          'It is last item',
          'Error',
          this.$store.state.snotify
        )
      }

      data[type] = data[type].filter((item, index) => index !== removeIndex)
    },
    clearEditRow (data) {
      if (data) {
        this.totalReports = JSON.parse(JSON.stringify(this.editData))
      }
      this.editRow = null
      this.editData = null
    },
    isEditType (index, type) {
      return this.editRow === `${type}-${index}`
    },
    addTableRow (row, type, index, data) {
      const insertData = cloneDeep(data)
      row[type].splice(index + 1, 0, insertData)
    },
    prepareReportsByCategory (data, type, setData) {
      let result = data

      if (!result[type].length) {
        result[type] = setData
      }

      return result
    },
    prepareDataForTotalReports (data) {
      let expensesTotal = this.prepareReportsByCategory(data.expensesTotal, 'categories', [this.config.mockForTable.expensesCategory])
      let payoutsTotal = this.prepareReportsByCategory(data.payoutsTotal, 'payees', [this.config.mockForTable.payouts])
      let invoicesTotal = this.prepareReportsByCategory(data.invoicesTotal, 'business_developers', [this.config.mockForTable.payments])

      return { expensesTotal, payoutsTotal, invoicesTotal }
    },
    setReportsDataTotalFromRequest (data) {
      const { expensesTotal, payoutsTotal, invoicesTotal } = this.prepareDataForTotalReports(data)
      const summary = data.summary

      this._setDataTotalReports({ expensesTotal, payoutsTotal, invoicesTotal, summary })
    }
  }
}

</script>

<style lang="scss">

  .nested-table {
    overflow: unset!important;
  }

  .report-table-total{
    thead{
      display: none;
    }
  }
  .report-table{
    table-layout: fixed;
  }
  .footer-controllers__right{
    display: flex;
    justify-content: flex-end;
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
</style>
